// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var QwickCircleSvg = require("../../img/qwick-circle.svg").default;
var QwickCircleWhiteSvg = require("../../img/qwick-circle-white.svg").default;

var make = QwickCircleSvg;

var Source = {
  make: make
};

var icon = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(2.0)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(2.0)),
        tl: /* [] */0
      }
    });

var Styles = {
  icon: icon
};

function BrowserComponents_Icon$QwickCircle(Props) {
  var className = Props.className;
  var tmp = {};
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("div", tmp, React.createElement(make, {}));
}

var QwickCircle = {
  Source: Source,
  Styles: Styles,
  make: BrowserComponents_Icon$QwickCircle
};

var make$1 = QwickCircleWhiteSvg;

var Source$1 = {
  make: make$1
};

var icon$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(2.0)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(2.0)),
        tl: /* [] */0
      }
    });

var Styles$1 = {
  icon: icon$1
};

function BrowserComponents_Icon$QwickCircleWhite(Props) {
  var className = Props.className;
  var tmp = {};
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("div", tmp, React.createElement(make$1, {}));
}

var QwickCircleWhite = {
  Source: Source$1,
  Styles: Styles$1,
  make: BrowserComponents_Icon$QwickCircleWhite
};

function container(size) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.height(size),
              tl: {
                hd: BrowserStyle.position(BrowserStyle.relative),
                tl: {
                  hd: BrowserStyle.width(size),
                  tl: {
                    hd: BrowserStyle.flexShrink(0.0),
                    tl: {
                      hd: BrowserStyle.selector("svg", {
                            hd: BrowserStyle.display(BrowserStyle.block),
                            tl: {
                              hd: BrowserStyle.height(BrowserStyle.pct(100.0)),
                              tl: {
                                hd: BrowserStyle.width(BrowserStyle.pct(100.0)),
                                tl: /* [] */0
                              }
                            }
                          }),
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

function container$1(colorOpt, size, param) {
  var color = colorOpt !== undefined ? colorOpt : ({
        TAG: /* Grey */2,
        _0: /* Dark */1
      });
  return Curry._1(BrowserStyle.merge, {
              hd: container(BrowserStyle.Icon.sizeToRem(size)),
              tl: {
                hd: Curry._1(BrowserStyle.style, {
                      hd: BrowserStyle.SVG.color(color),
                      tl: /* [] */0
                    }),
                tl: /* [] */0
              }
            });
}

function notificationDot(color, size) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.border(BrowserStyle.Point.toRem(Curry._2(BrowserStyle.Point.multiplyWithFloat, 0.1875, Curry._1(BrowserStyle.Icon.Size.toPoint, size))), BrowserStyle.solid, color),
              tl: {
                hd: BrowserStyle.borderRadius(BrowserStyle.pct(50.0)),
                tl: {
                  hd: BrowserStyle.right(BrowserStyle.zero),
                  tl: {
                    hd: BrowserStyle.position(BrowserStyle.absolute),
                    tl: {
                      hd: BrowserStyle.top(BrowserStyle.zero),
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

var Styles$2 = {
  container: container$1,
  notificationDotRadiusScale: 0.1875,
  notificationDot: notificationDot
};

var make$2 = React.forwardRef(function (Props, ref_) {
      var className = Props.className;
      var color = Props.color;
      var icon = Props.icon;
      var notificationDotColor = Props.notificationDotColor;
      var onMouseEnter = Props.onMouseEnter;
      var onMouseLeave = Props.onMouseLeave;
      var sizeOpt = Props.size;
      var testId = Props.testId;
      var title = Props.title;
      var size = sizeOpt !== undefined ? sizeOpt : /* Medium */2;
      var tmp = {
        className: BrowserStyle.Utils.extendBaseStyle(container$1(color, size, undefined), className)
      };
      var tmp$1 = Relude_Option.map((function (prim) {
              return prim;
            }), (ref_ == null) ? undefined : Caml_option.some(ref_));
      if (tmp$1 !== undefined) {
        tmp.ref = Caml_option.valFromOption(tmp$1);
      }
      if (title !== undefined) {
        tmp.title = Caml_option.valFromOption(title);
      }
      var tmp$2 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onMouseEnter);
      if (tmp$2 !== undefined) {
        tmp.onMouseEnter = Caml_option.valFromOption(tmp$2);
      }
      var tmp$3 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onMouseLeave);
      if (tmp$3 !== undefined) {
        tmp.onMouseLeave = Caml_option.valFromOption(tmp$3);
      }
      var tmp$4 = {
        children: React.createElement("div", tmp, BrowserStyle.Icon.toElement(icon), Relude_Option.fold(null, (function (color) {
                    return React.createElement("div", {
                                className: notificationDot(color, size)
                              });
                  }), notificationDotColor))
      };
      if (testId !== undefined) {
        tmp$4.id = Caml_option.valFromOption(testId);
      }
      return React.createElement(ReactUtils.WithTestId.make, tmp$4);
    });

exports.QwickCircle = QwickCircle;
exports.QwickCircleWhite = QwickCircleWhite;
exports.Styles = Styles$2;
exports.make = make$2;
/* make Not a pure module */
